import SalarieSummary from '@/generated/controls/salarie/SalarieSummary.vue';
import { Sections } from '@/generated/classes/AppSchema';
import Salarie from '@/generated/classes/Salarie';
import { storeSession, storeSalarie } from '@/generated/stores';
import { defineComponent } from "vue";

export default defineComponent({ components: {},
    extends: SalarieSummary,
    methods: {
        getDisplay(salarie: Salarie): string {
            let res = "";
            const pseudo = salarie.pseudo != "" ? " (" + salarie.pseudo + ")" : "";
            res = salarie.prenom + " " + salarie.nom + pseudo;
            return res;
        },
        getItems(salaries: Salarie[], section: Sections): Salarie[] {
            const connectedUser = storeSession.connectedUser;
            return salaries.filter(a => a.id != connectedUser?.id);;
        }
    }
})
